import { Popover } from 'antd';
export const ViewIcon = () => {
  return (
    <Popover content="View" placement="topRight">
      <div className="w-4">
        <img
          alt="view"
          src="https://img.icons8.com/material-outlined/24/null/visible--v1.png"
        />
      </div>
    </Popover>
  );
};
